// some of the scripts are loaded asynchronously and there are no APIs to detect when they are done loading, so we need
// to keep "polling" the global scope, until the features we need are available.
export default ((test, {
  timeout = 60000,
  interval = 250
} = {}) => new Promise((resolve, reject) => {
  if (test()) {
    resolve();
    return;
  }
  const initTime = Date.now();
  const timerId = setInterval(() => {
    if (test()) {
      clearInterval(timerId);
      resolve();
    }
    if (Date.now() - initTime >= timeout) {
      clearInterval(timerId);
      reject();
    }
  }, interval);
}));